import { getCurrentInstance, onMounted, ref } from 'vue';
import { getFirstDayOfWeek } from './first-day-map';

export function useFirstDayOfWeek(defaultFirstDay = 7) {
    const firstDayOfWeek = ref(defaultFirstDay);

    onMounted(() => {
        const inst = getCurrentInstance();
        const proxy: any = inst?.proxy;
        const parentI18n = proxy?.$i18n || proxy?.$root?.$i18n;
        if (!parentI18n) return;
        const locale: string = parentI18n.locale;
        const region = locale?.split('-')[1];
        if (region) {
            const deduced = getFirstDayOfWeek(region);
            if (deduced) firstDayOfWeek.value = deduced;
        }
    });

    return { firstDayOfWeek };
}
